import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'react-bootstrap';
import CreateDomainForm from './CreateDomainForm';
import { useAppSelector, useAppDispatch } from '../../../hooks/redux/hooks';
import { domainState, listDomains } from '../domainSlice';

const CreateDomainModal = () => {
    const { createdDomain } = useAppSelector(domainState);
    const [show, setShow] = useState(false);
    const dispatch = useAppDispatch();
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        if (createdDomain.isSuccess) {
            handleClose();
        }
    }, [createdDomain, dispatch]);


    return (
        <>
            <Button onClick={handleShow}> Create Domain </Button>
            <Modal centered show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Create Domain</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CreateDomainForm />
                </Modal.Body>
                {!createdDomain.isLoading && <Modal.Footer>
                    <Button variant="light" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button form='createDomain-form' variant="primary" type="submit">
                        Create
                    </Button>
                </Modal.Footer>}
            </Modal>
        </>

    )
}

export default CreateDomainModal